/* eslint-disable react/jsx-no-useless-fragment */
import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { useAuth } from 'hooks';
import { getUIVersion } from 'utils/router-static-data';

export default function ACL({ action, module, children }) {
	const authData = useAuth();
	const isV2 = getUIVersion() === 'new';
	const permissions = isV2 ? authData?.v2_permissions : authData?.permissions;

	if (permissions?.[action]?.includes(module) || permissions?.[action]?.includes('all')) {
		return <>{children}</>;
	}

	return null;
}

ACL.propTypes = {
	action: PropTypes.string,
	module: PropTypes.string,
	children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]),
};
